// extracted by mini-css-extract-plugin
module.exports = {"modal":"Order-module_modal_3GIJB","body":"Order-module_body_2A9Fp","form":"Order-module_form_2DKCk"};